import{useConfigStore as t}from"@phx-husky/auth-context";import r from"@phx-husky/auth-service";import{useRef as e}from"react";const o=()=>{const{services:o,config:c}=t(),{current:n}=e(r.getInstance(o,c));return n};export{o as useAuth};
